import InsuranceValidation from './InsuranceValidation';

export default InsuranceValidation;